/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { InputDetail, ItemInfo, LegendSection } from './Legend.type';

function getItem<K>(itemInfo: ItemInfo, sections: LegendSection<K>[]) {
  const { sectionIdx, itemIdx } = itemInfo;

  if (sectionIdx == -1 && itemIdx == -1) {
    const itemsLength = sections[sections.length - 1].items.length;
    return sections[sections.length - 1].items[itemsLength - 1];
  }

  return sections[sectionIdx].items[itemIdx];
}

function getNextItemInfo<K>(itemInfo: ItemInfo, sections: LegendSection<K>[]) {
  let { itemIdx, sectionIdx } = itemInfo;

  if (sectionIdx == -1 && itemIdx == -1) {
    return {
      itemIdx: sections[sections.length - 1].items.length - 1,
      sectionIdx: sections.length - 1
    };
  }

  itemIdx += 1;
  const itemsLength = sections[sectionIdx].items.length;
  if (itemIdx >= itemsLength) {
    if (sectionIdx === sections.length - 1) {
      itemIdx = itemInfo.itemIdx;
    } else {
      sectionIdx += 1;
      itemIdx = 0;
    }
  }
  return { itemIdx, sectionIdx };
}

function getPrevItemInfo<K>(itemInfo: ItemInfo, sections: LegendSection<K>[]) {
  let { itemIdx, sectionIdx } = itemInfo;

  if (sectionIdx == -1 && itemIdx == -1) {
    (itemIdx = sections[sections.length - 1].items.length - 1), (sectionIdx = sections.length - 1);
  }
  itemIdx -= 1;

  if (itemIdx < 0) {
    if (sectionIdx === 0) {
      itemIdx = 0;
    } else {
      itemIdx = sections[sectionIdx - 1].items.length - 1;
      sectionIdx -= 1;
    }
  }
  return { itemIdx, sectionIdx };
}

/**
 * Returns utils functions for navigation in simple sectional legend.
 * @param items
 * @returns
 */
export function getSectionalNavUtils<K>(sections: LegendSection<K>[]) {
  return {
    getItem: (itemInfo: ItemInfo) => {
      return getItem(itemInfo, sections);
    },
    getDetailFromInfo: (itemInfo?: ItemInfo): InputDetail<K> => {
      if (!itemInfo) {
        return { itemId: undefined, sectionId: undefined };
      }
      const item = getItem(itemInfo, sections);
      const sectionId = sections[itemInfo.sectionIdx].id;
      return { itemId: item.id, sectionId: sectionId };
    },
    getPrevItemInfo: (itemInfo: ItemInfo) => {
      return getPrevItemInfo(itemInfo, sections);
    },
    getNextItemInfo: (itemInfo: ItemInfo) => {
      return getNextItemInfo(itemInfo, sections);
    }
  };
}
